
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"75","height":"75","viewBox":"0 0 75 75"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('Amazon-EventBridge_dark-bg')]),_c('g',{attrs:{"id":"Example"}},[_c('rect',{staticStyle:{"fill":"#ff4f8b"},attrs:{"id":"Green_Dark_BG","data-name":"Green Dark BG","width":"75","height":"75"}}),_c('path',{staticStyle:{"fill":"#232f3e"},attrs:{"d":"M21.89,53.76A5.9,5.9,0,0,0,16,43.55l-3.5-6,5.79-10-1.73-1L10.48,37a1,1,0,0,0,0,1l3.89,6.74a5.91,5.91,0,0,0,4.25,10,6.15,6.15,0,0,0,1.43-.18l3.19,5.52a1,1,0,0,0,.86.5H36.5v-2H24.68Zm-3.27-1a3.91,3.91,0,1,1,3.91-3.91A3.92,3.92,0,0,1,18.62,52.75ZM64.52,37l-3.8-6.58a5.9,5.9,0,0,0-5.86-10.15l-3.1-5.36a1,1,0,0,0-.86-.5H38.5v2H50.32l2.86,5a5.91,5.91,0,0,0,5.76,10L62.5,37.5l-5,8.65,1.74,1L64.52,38A1,1,0,0,0,64.52,37Zm-7.33-7.4a3.91,3.91,0,1,1,3.91-3.91A3.91,3.91,0,0,1,57.19,29.6Zm-6,24.08a5.85,5.85,0,0,0-2.1.4l-4.25-7.17-.22.13,5.22-9a1,1,0,0,0,0-1L44.1,27a1,1,0,0,0-.86-.5H32.73l0,0L28.88,19.9a5.9,5.9,0,1,0-3.83,1.42,6,6,0,0,0,2.11-.4l3.63,6.14L25.05,37a1,1,0,0,0,0,1l5.78,10a1,1,0,0,0,.86.5H43.24a1,1,0,0,0,.24,0l3.93,6.63a5.89,5.89,0,1,0,3.82-1.42ZM25.05,19.32A3.91,3.91,0,1,1,29,15.41,3.92,3.92,0,0,1,25.05,19.32ZM42.66,46.5H32.27l-5.2-9,5.2-9H42.66l5.2,9Zm8.57,17a3.91,3.91,0,1,1,3.91-3.91A3.92,3.92,0,0,1,51.23,63.5Z"}})])])
          )
        }
      }
    